import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'

/**
 * Document的Context
 */
export class DocumentContext {
  /**
   * instance
   */
  static _instance = null
  /**
   * constructor
   */
  constructor(obj) {
    if (obj instanceof DocumentContext) {
      this._data = obj._data
    } else {
      this._data = {
        loading: false,
        user: null,
        officeList: null,
        office: null,
        config: null
      }
      cache.load(cacheName.USER, cacheName.OFFICE_LIST).then(() => {
        this._data.user = cache.user
        this._data.officeList = cache.officeList
      })
    }
  }
  get loading() {
    return this._data.loading
  }
  set loading(loading) {
    this._data.loading = loading
  }
  get user() {
    return this._data.user
  }
  set user(user) {
    this._data.user = user
  }
  get officeList() {
    return this._data.officeList
  }
  set officeList(officeList) {
    this._data.officeList = officeList
  }
  get office() {
    return this._data.office
  }
  set office(office) {
    this._data.office = office
  }
  get config() {
    return this._data.config
  }
  set config(config) {
    this._data.config = config
  }
  /**
   * 获取实例
   */
  static getInstance() {
    if (!this._instance) {
      this._instance = new DocumentContext()
    }
    return this._instance
  }
  /**
   * 准备好数据
   */
  async prepareData() {
    const loading = getLoading()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.config = cache.config
    loading.close()
  }
}
